module.exports = __webpack_public_path__ + "img/notification-email.f6b05fb2.svg";